import { useState } from "react";
import { STATUS, MANUAL_STATUS, rpc, fmtDateTime } from "@/lib/booking";
import { Ok, Err, useAction, inputCls, smallBtn } from "./adminUI";

const CLOSED = ["cancelled", "refunded", "expired"];

export function BookingActions({ b, slots, role }) {
    const { run, busy, msg, err } = useAction();
    const [status, setStatus] = useState(b.status);
    const [note, setNote] = useState("");
    const [slotId, setSlotId] = useState("");
    const [pay, setPay] = useState({ kind: "payment", method: "pix", amount: "" });
    const canPay = role !== "staff";

    const changeStatus = () => {
        if (!window.confirm(`Alterar para "${STATUS[status]}"?`)) return;
        run(() => rpc("admin_update_booking_status", { p_id: b.id, p_status: status, p_note: note }), "Status atualizado");
    };
    const reschedule = () => run(() => rpc("admin_reschedule_booking", { p_id: b.id, p_slot: slotId, p_note: note }), "Reagendado");
    const registerPay = () => {
        if (!window.confirm(`Registrar ${pay.kind === "payment" ? "pagamento" : "reembolso"} de R$ ${pay.amount}?`)) return;
        run(() => rpc("admin_register_payment", { p_id: b.id, p_kind: pay.kind, p_method: pay.method, p_amount: Number(pay.amount), p_note: note, p_ref: null }), "Registrado");
    };

    return (
        <div className="space-y-3 rounded-2xl border border-ink/10 p-4" data-testid={`booking-actions-${b.code}`}>
            <input className={inputCls + " mt-0"} placeholder="Observação interna para o histórico (opcional)" value={note} onChange={(e) => setNote(e.target.value)} data-testid={`booking-note-${b.code}`} />
            <div className="flex flex-wrap items-center gap-2">
                <select className={inputCls + " mt-0 w-auto"} value={status} onChange={(e) => setStatus(e.target.value)} data-testid={`booking-status-select-${b.code}`}>
                    {[...new Set([b.status, ...MANUAL_STATUS])].map((s) => <option key={s} value={s}>{STATUS[s]}</option>)}
                </select>
                <button className={smallBtn} disabled={busy || status === b.status} onClick={changeStatus} data-testid={`booking-status-apply-${b.code}`}>Alterar status</button>
                {b.status === "pending_review" && <button className={smallBtn} disabled={busy} data-testid={`booking-confirm-${b.code}`}
                    onClick={() => run(() => rpc("admin_update_booking_status", { p_id: b.id, p_status: "confirmed", p_note: note }), "Confirmada")}>Confirmar vaga</button>}
            </div>
            {!CLOSED.includes(b.status) && slots.length > 0 && <div className="flex flex-wrap items-center gap-2">
                <select className={inputCls + " mt-0 w-auto"} value={slotId} onChange={(e) => setSlotId(e.target.value)} data-testid={`booking-reschedule-select-${b.code}`}>
                    <option value="">{b.slot_id ? "Reagendar para…" : "Definir horário…"}</option>
                    {slots.map((s) => <option key={s.id} value={s.id}>{fmtDateTime(s.starts_at)}</option>)}
                </select>
                <button className={smallBtn} disabled={busy || !slotId} onClick={reschedule} data-testid={`booking-reschedule-${b.code}`}>Reagendar</button>
            </div>}
            {canPay && <div className="flex flex-wrap items-center gap-2">
                <select className={inputCls + " mt-0 w-auto"} value={pay.kind} onChange={(e) => setPay({ ...pay, kind: e.target.value })} data-testid={`booking-pay-kind-${b.code}`}>
                    <option value="payment">Pagamento manual</option><option value="refund">Reembolso</option></select>
                <span className="rounded-full border border-neon-cyan/30 px-3 py-2 text-xs text-neon-cyan" data-testid={`booking-pix-only-${b.code}`}>Pix</span>
                <input type="number" min="0" step=".01" placeholder="Valor" className={inputCls + " mt-0 w-32"} value={pay.amount}
                    onChange={(e) => setPay({ ...pay, amount: e.target.value })} data-testid={`booking-pay-amount-${b.code}`} />
                <button className={smallBtn} disabled={busy || !(Number(pay.amount) > 0)} onClick={registerPay} data-testid={`booking-pay-submit-${b.code}`}>Registrar</button>
            </div>}
            <div className="flex gap-3"><Ok msg={msg} /><Err msg={err} /></div>
        </div>
    );
}
